var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlueEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_406",
    "data-name": "Group 406",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.801,
    height: 22.807,
    viewBox: "0 0 22.801 22.807",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    d: "M0,29.294a2.654,2.654,0,0,1,.777-1.4,2.425,2.425,0,0,1,1.681-.655q4.828-.01,9.655,0a.868.868,0,0,1,.93.822.848.848,0,0,1-.84.859,3.144,3.144,0,0,1-.355.013H2.7c-.119,0-.238,0-.356.009a.763.763,0,0,0-.687.676,1.774,1.774,0,0,0-.005.178q0,8.042,0,16.085a1.03,1.03,0,0,0,.042.351.769.769,0,0,0,.7.531c.185.009.371,0,.556,0H16.969a.791.791,0,0,0,.882-.614,1.612,1.612,0,0,0,.023-.353q0-3.893,0-7.786a1.316,1.316,0,0,1,.045-.418.833.833,0,0,1,1.625.2c.005.089,0,.178,0,.267,0,2.573-.026,5.147.011,7.72A2.546,2.546,0,0,1,17.592,48.4a.317.317,0,0,0-.061.026H2A3.128,3.128,0,0,1,.994,47.98,2.63,2.63,0,0,1,0,46.424Z",
    transform: "translate(0 -25.619)",
    fill: "#2a77eb"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    d: "M99.758,3.152a3.077,3.077,0,0,1-.849,2.137c-.171.185-.353.36-.531.538q-5.048,5.048-10.094,10.1a1.7,1.7,0,0,1-.688.43q-2.259.745-4.514,1.5a1.23,1.23,0,0,1-.545.074.81.81,0,0,1-.708-.915,1.964,1.964,0,0,1,.087-.344q.762-2.288,1.527-4.575a1.394,1.394,0,0,1,.345-.561Q89.067,6.261,94.343.985a3.129,3.129,0,0,1,4.625.073,3.015,3.015,0,0,1,.79,2.093",
    transform: "translate(-76.957 0)",
    fill: "#2a77eb"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueEditIcon);
export default __webpack_public_path__ + "static/media/blue_edit_icon.edb710ee0be71a795ebfacb3b73d84f7.svg";
export { ForwardRef as ReactComponent };